import React, { Component } from "react";
import { Spin, message } from "antd";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Bridge from "./utils/Bridge";
import { RESEARCH_TYPE } from "./utils/consts";

class ForgotPassword extends Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      loading: false,
      type1: "password",
      is_otp_sent: false,
      is_otp_verified: false,
      otp: "",

      new_password: "",
      confirm_password: "",
      newp_type: "password",
      confirmp_type: "password",
    };
  }
  // on change inputs
  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  // show hide password
  togglePassword = (param) => {
    if (param == "new") {
      this.setState({
        newp_type: this.state.newp_type == "password" ? "text" : "password",
      });
    } else if (param == "confirm") {
      this.setState({
        confirmp_type:
          this.state.confirmp_type == "password" ? "text" : "password",
      });
    }
  };
  // send otp
  send_otp = () => {
    if (!this.state.email) {
      message.warning("Email address is required");
      return;
    }
    let params = {
      email: this.state.email,
      research_type: RESEARCH_TYPE,
    };
    this.setState({ loading: true });
    Bridge.forgot_password
      .send_otp(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState({ loading: false, is_otp_sent: true });
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  // verify
  verify_otp = () => {
    if (!this.state.email) {
      message.warning("Email address is required");
      return;
    }
    if (!this.state.otp) {
      message.warning("Please enter OTP");
      return;
    }
    if (this.state.otp.length != 6) {
      message.warning("Invalid OTP");
      return;
    }
    let params = {
      email: this.state.email,
      otp: this.state.otp,
      research_type: RESEARCH_TYPE,
    };
    this.setState({ loading: true });
    Bridge.forgot_password
      .verify_otp(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState({ loading: false, is_otp_verified: true });
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  reset_password = () => {
    if (!this.state.email) {
      message.warning("Invalid request");
      return;
    }
    if (!this.state.new_password) {
      message.warning("Please enter new password.");
      return;
    }
    if (!this.state.confirm_password) {
      message.warning("Please enter confirm password.");
      return;
    }
    let params = {
      email: this.state.email,
      new_password: this.state.new_password,
      confirm_password: this.state.confirm_password,
      research_type: RESEARCH_TYPE,
    };
    this.setState({ loading: true });
    Bridge.forgot_password
      .reset_password(params)
      .then((response) => {
        if (response.data.status == "1") {
          message.success(response.data.message);
          this.setState({ loading: false }, () => {
            setTimeout(() => {
              window.location.assign("/");
            }, 3000);
          });
        } else {
          message.error(response.data.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        message.warning("Please try again!!", error);
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <>
        <Header />
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="authenitication-form">
                <div className="dark-side d-none d-sm-none d-md-none d-lg-block d-xl-block">
                  <img src={"./assets/images/dark-logo.jpg"} />
                  <p className="inner-text">
                    Our mission is to support efforts to care for ALS patients
                    and work to find treatments. We believe the technology will
                    be a key enabler for the innovation to end ALS, we are here
                    to bridge the gap between patients, research and technology.
                  </p>
                  
                </div>
                <div className="right-sides-form">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <h2
                          style={{
                            marginBottom: 0,
                            paddingBottom: 10,
                          }}
                        >
                          Reset Password
                        </h2>
                        <p style={{ fontSize: 17 }}>
                          Enter your e-mail to receive instructions on how to
                          reset your password.
                        </p>
                        <p style={{ fontSize: 17 }}>
                          NOTE: You must first register and confirm your account
                          via email before resetting your password.
                        </p>
                        <div className="mt-4">
                          <Spin spinning={this.state.loading}>
                            {this.state.is_otp_verified == true ? (
                              <div className="form-wrapper">
                                <div className="form-field">
                                  <label>
                                    <box-icon
                                      style={{
                                        marginTop:
                                          window.innerWidth > 600 ? 0 : -3,
                                        marginRight:
                                          window.innerWidth > 600 ? 12 : 9,
                                      }}
                                      name="lock-alt"
                                      type="solid"
                                      color="#9e9e9e"
                                      size={
                                        window.innerWidth > 600
                                          ? "23px"
                                          : "23px"
                                      }
                                    ></box-icon>
                                    New Password
                                  </label>
                                  <input
                                    type={this.state.newp_type}
                                    name="password"
                                    value={this.state.new_password}
                                    onChange={(e) =>
                                      this.setState({
                                        new_password: e.target.value,
                                      })
                                    }
                                  />
                                  <div
                                    className="togglePassword"
                                    onClick={() => this.togglePassword("new")}
                                  >
                                    {this.state.newp_type == "password" ? (
                                      <div className="show-password-icon">
                                        <box-icon
                                          name="show"
                                          color="#ffa3a3"
                                        ></box-icon>
                                      </div>
                                    ) : (
                                      <div className="show-password-icon">
                                        <box-icon
                                          name="low-vision"
                                          color="#ffa3a3"
                                        ></box-icon>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <div className="form-field">
                                  <label>
                                    <box-icon
                                      style={{
                                        marginTop:
                                          window.innerWidth > 600 ? 0 : -3,
                                        marginRight:
                                          window.innerWidth > 600 ? 12 : 9,
                                      }}
                                      name="lock-alt"
                                      type="solid"
                                      color="#9e9e9e"
                                      size={
                                        window.innerWidth > 600
                                          ? "23px"
                                          : "23px"
                                      }
                                    ></box-icon>
                                    Confirm Password
                                  </label>
                                  <input
                                    type={this.state.confirmp_type}
                                    name="password"
                                    value={this.state.confirm_password}
                                    onChange={(e) =>
                                      this.setState({
                                        confirm_password: e.target.value,
                                      })
                                    }
                                  />
                                  <div
                                    className="togglePassword"
                                    onClick={() =>
                                      this.togglePassword("confirm")
                                    }
                                  >
                                    {this.state.confirmp_type == "password" ? (
                                      <div className="show-password-icon">
                                        <box-icon
                                          name="show"
                                          color="#ffa3a3"
                                        ></box-icon>
                                      </div>
                                    ) : (
                                      <div className="show-password-icon">
                                        <box-icon
                                          name="low-vision"
                                          color="#ffa3a3"
                                        ></box-icon>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                <center>
                                  <button
                                    type="button"
                                    className="submit-button full-width"
                                    onClick={() => this.reset_password()}
                                  >
                                    <box-icon
                                      name="log-in"
                                      color="#fff"
                                      size={"20px"}
                                    ></box-icon>
                                    &nbsp; CHANGE PASSWORD
                                  </button>
                                </center>
                              </div>
                            ) : (
                              <div className="form-wrapper">
                                <div className="form-field">
                                  <label>
                                    <box-icon
                                      type="solid"
                                      name="envelope"
                                      color="#9e9e9e"
                                      size={
                                        window.innerWidth > 600
                                          ? "23px"
                                          : "23px"
                                      }
                                      style={{
                                        marginTop:
                                          window.innerWidth > 600 ? 0 : -3,
                                        marginRight:
                                          window.innerWidth > 600 ? 12 : 9,
                                      }}
                                    ></box-icon>{" "}
                                    Your registered e-mail:
                                  </label>
                                  <input
                                    type="text"
                                    name="email"
                                    value={this.state.email}
                                    onChange={this.handleChange}
                                    disabled={
                                      this.state.is_otp_sent == true
                                        ? true
                                        : false
                                    }
                                  />
                                </div>
                                {this.state.is_otp_sent == true && (
                                  <div className="form-field">
                                    <label>
                                      <box-icon
                                        type="solid"
                                        name="envelope"
                                        color="#9e9e9e"
                                        size={
                                          window.innerWidth > 600
                                            ? "23px"
                                            : "23px"
                                        }
                                        style={{
                                          marginTop:
                                            window.innerWidth > 600 ? 0 : -3,
                                          marginRight:
                                            window.innerWidth > 600 ? 12 : 9,
                                        }}
                                      ></box-icon>{" "}
                                      OTP
                                    </label>
                                    <input
                                      type="number"
                                      name="otp"
                                      value={this.state.otp}
                                      onChange={(e) =>
                                        this.setState({ otp: e.target.value })
                                      }
                                      maxLength={6}
                                    />
                                  </div>
                                )}
                                <center>
                                  {this.state.is_otp_sent == true ? (
                                    <button
                                      type="button"
                                      className="submit-button full-width"
                                      onClick={() => this.verify_otp()}
                                    >
                                      <box-icon
                                        name="log-in"
                                        color="#fff"
                                        size={"20px"}
                                      ></box-icon>
                                      &nbsp; VERIFY OTP
                                    </button>
                                  ) : (
                                    <button
                                      type="button"
                                      className="submit-button full-width"
                                      onClick={() => this.send_otp()}
                                    >
                                      <box-icon
                                        name="log-in"
                                        color="#fff"
                                        size={"20px"}
                                      ></box-icon>
                                      &nbsp; RESET MY PASSWORD
                                    </button>
                                  )}
                                </center>
                              </div>
                            )}
                          </Spin>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </>
    );
  }
}
export default ForgotPassword;
